import {React,useState,useEffect} from "react";
import {useHistory} from 'react-router-dom'
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';

import './ProductMobile.scss'
import defaultmage from'../../assets/images/product.png';
import { useDispatch } from "react-redux";
import { updateCustomer } from '../../ReduxActions/customerAction';
import {changeNumbers} from '../Common/regex'
import NotFound from './../NotFound/NotFound';

const ProductMobile= ({code,productImage,serviceType,title1,title2,title3,title4,title5,title6,mainPrice,discountPrice,canSelect,selected,productDes,isEquipment,hasEquipment}) => {

    const [showPopup,setShowPopup] = useState(false);

    const dispatch = useDispatch();
    const history = useHistory();

    const customer = useSelector(state => state.customer);

    const [getSelected,setSelected] = useState(customer.serviceCode === code && canSelect ? 1 : 0);

    const handleSelectPackage = () =>{
        if(canSelect){
            if(!isEquipment){
                dispatch(updateCustomer({serviceCode:code,serviceWithModem:hasEquipment}));
            }
            else{
                dispatch(updateCustomer({equipmentCode:code}));
            }
        }
        else{

            if(customer.CustomerCode && customer.CustomerCode!=0 && customer.serviceType!=serviceType){
                dispatch(updateCustomer({
                    FillInfo:0,
                    Name:'',
                    Family:'',
                    Melli:'',
                    Mobile:'',
                    //Phone:'',
                    //PrePhone:'021',
                    //PhonePure:'',
                    ZipCode:'',
                    Address:'',
                    Year:'0',
                    Month:'0',
                    Day:'0',
                    Sex:'1',
                    City:'0',
                    Region:'0',
                    Know:'0',
                    CustomerCode:0,
                    FactorCode:0,
                }));
            }

            dispatch(updateCustomer({serviceCode:code,serviceType:serviceType,ServiceHasEquipment:hasEquipment}));
            if(serviceType === 1)
                history.push("/checkPhone");
            else
                history.push("/serviceShow");
        }
    }

    const handleUnselect = () =>{
        if(!isEquipment)
            dispatch(updateCustomer({serviceCode:0,serviceWithModem:false}));
        else
            dispatch(updateCustomer({equipmentCode:0}));
    }

    useEffect( () => {
        if(selected && !isEquipment){
            setSelected(1);
            dispatch(updateCustomer({serviceCode:code}));
        }
   },[]);

   useEffect( () => {
        setSelected(customer.serviceCode === code && canSelect ? 1 : 0);
    },[customer.serviceCode]);

   const handlePackageInfo=()=>{
        setShowPopup(true);
        console.log('StoreLog: ',{productDes});
   }

    return ( 
        <>
        <Modal classNames={{closeIcon:"modalCloseEquip",modal:"modalEquip"}} open={showPopup} onClose={() => setShowPopup(false)} center>
            <h3 className="modalTitle">مشخصات تجهیزات</h3>
            <div className="modalBodyEquip" dangerouslySetInnerHTML={{ __html: productDes }} />
        </Modal>

        <div className={`productMobile${getSelected === 1 ? (serviceType === 1 ? " productSelectedADSL" : (serviceType === 2 ? " productSelectedLTE" : " productSelectedGaming")) : "" }`} 
        onClick={canSelect && getSelected !=1 ? handleSelectPackage : null}
        >
            <div className="topPart">
                <div className="productImageP">
                    {getSelected != 1 ?
                        <div className="productImage">
                            <img src={productImage != "" ? productImage : defaultmage }></img>
                        </div>
                        :
                        <div className="productImageSelected">
                            <span onClick={handleUnselect}>
                                <i className={`fa fa-check ${serviceType === 1 ? "colorADSL" : (serviceType === 2 ? "colorLTE" : "colorGaming")}`}></i>
                            </span>
                        </div>
                    }
                </div>
                <div className="productDetailsP">
                    <div className="productDetails">
                            {
                                title1 !='' || customer.ShowStar ?
                                <div className="divTitleDiscount">
                                    {
                                        title1 !=''?
                                        <span className={`serviceType ${getSelected !=1 ? (serviceType === 1 ? "colorADSL" : (serviceType === 2 ? "colorLTE" : "colorGaming")) : "colorWhite"}`}>{title1}</span>
                                        :<span className="serviceType"/>
                                    }
                                    {
                                        customer.ShowStar ?
                                        <div className="discount">
                                            {mainPrice === discountPrice ? null :
                                                <div>
                                                    <span className="discountP"> % </span>
                                                    <span className="discountP">{changeNumbers(parseInt(100- (( discountPrice / mainPrice)*100)))}</span>
                                                </div>
                                            }
                                        </div>
                                        :null
                                    }
                                </div>
                                :null
                            }
                            <span className={`serviceTimeTraffic ${getSelected !=1 ? (title1 !='' ? "colorBlack" : (serviceType === 1 ? "colorADSL" : (serviceType === 2 ? "colorLTE" : "colorGaming"))) : "colorSelected"}`}>{title2}</span>
                            <span className={`serviceTimeTraffic ${getSelected !=1 ? (title1 !='' ? "colorBlack" : (serviceType === 1 ? "colorADSL" : (serviceType === 2 ? "colorLTE" : "colorGaming"))) : "colorSelected"}`}>{title3}</span>

                            <span className={`serviceDes ${getSelected !=1 ? "colorGray" : "colorSelected"}`}>{title4}</span>
                            <span className={`serviceDes ${getSelected !=1 ? "colorGray" : "colorSelected"}`}>{title5}</span>

                            {
                                (productDes === '' || productDes === undefined) ? <span className={`serviceDes ${getSelected !=1 ? "colorGray" : "colorSelected"}`}>{title6}</span> :
                                <span className={`serviceInfo ${getSelected !=1 ? "colorPrice" : "colorSelected"}`} onClick={handlePackageInfo}>{title6}</span>
                            }
                    </div>
                </div>
            </div>
            <div className="bottomPart">
                <div className="buyProductP">
                    {canSelect && getSelected !=1 &&
                        <div className="buyProduct">
                            {/* <span className="fa fa-shopping-cart"></span> */}
                            <span/>
                            <div>خرید</div>
                        </div>
                    }
                </div>
                <div className="servicePrice">
                    <div className={`discountPrice ${getSelected !=1 ? "colorPrice" : "colorWhite"}`}>
                        <span>{changeNumbers(discountPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))}</span>
                        <label>ریال</label>
                    </div>
                    <div className={`mainPrice ${getSelected !=1 ? "colorGray" : "colorWhite"} ${mainPrice === discountPrice ? "marginTop" : ""}`}>
                        {mainPrice === discountPrice ? null :
                            <>
                            <span>{changeNumbers(mainPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))}</span>
                            <div className="divDiscount">
                                <span> % </span>
                                <span>{changeNumbers(parseInt(100- (( discountPrice / mainPrice)*100)))}</span>
                            </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    </>
     );
}

export default ProductMobile;
